const ContactLensesData=[
    {   
        ID:1, 
        Title:'Alcon',
        ContactLensesLensesImg:'/ContactLenses/Alcon.png',
    },
    {   
        ID:2,
        Title :'Baush + Lomb',
        ContactLensesLensesImg:'/ContactLenses/BL.png'
        
    },
    {
        ID:3,
        Title:'Jhonson and Jhonson',
       ContactLensesLensesImg:'/ContactLenses/JJ.png',
    },
    {
        ID:4,
        Title:'CooperVision',
        ContactLensesLensesImg:'/ContactLenses/CV.png',
    },
    {
        ID:5,
        Title:"BioTrue Solution",
        ContactLensesLensesImg:'/ContactLenses/BIOTrue-soln.png',
        SolDescription:"BioTrue is a multipurpose contact lens solution designed to clean, rinse, disinfect, and store soft contact lenses. Its unique formulation closely matches the natural pH and tear composition of the eyes, providing enhanced comfort and effective lens care.",
    },
    {
        ID:6,
        Title:"RenuFresh Solution",
        ContactLensesLensesImg:'/ContactLenses/Renu-Fresh-Soln.png',
        SolDescription:"Renü is a versatile contact lens solution that cleans, rinses, disinfects, and stores soft contact lenses. It is formulated to provide enhanced comfort and optimal lens hygiene by effectively removing debris and maintaining lens moisture.",
    },
    {
        ID:7,
        Title:"OptiFree Solution",
        ContactLensesLensesImg:'/ContactLenses/OPTIFREE-soln.png',
        SolDescription:"Opti-Free is a multipurpose contact lens solution designed for cleaning, rinsing, disinfecting, and storing soft contact lenses. Its advanced HydraGlyde® Moisture Matrix technology helps keep lenses moist and comfortable all day by providing long-lasting hydration. Additionally, it effectively removes debris and deposits, ensuring clear vision and eye health.",
    },
]
export default ContactLensesData;